import { createApi } from "@reduxjs/toolkit/query/react";
import { getFastApiBaseUrl } from "../const/env";
import { authedFetchBaseQuery } from "./authedFetchBaseQuery";

const getBaseUrl = (): string => getFastApiBaseUrl();

export const uidDictApi = createApi({
  reducerPath: "uidDictApi",

  baseQuery: authedFetchBaseQuery({ baseUrl: getBaseUrl(), credentials: "include" }),

  tagTypes: ["UidDict"],

  endpoints: (builder) => ({
    getUidDict: builder.query({
      query: (request: unknown) => ({
        url: "sds_group_users/",
        method: "POST",
        body: request,
      }),
      providesTags: ["UidDict"],
    }),
    updateUidDict: builder.mutation({
      query: (request: unknown) => ({
        url: "sds_group_users/",
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["UidDict"],
    }),
    deleteUidDict: builder.mutation({
      query: (request: unknown) => ({
        url: "sds_group_users/",
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["UidDict"],
    }),
    getSearchableList: builder.query({
      query: ({ collectionName = "tabbed_dict" }: { collectionName?: string } = {}) => ({
        url: "sds_group_users/searchable_list",
        method: "GET",
        params: { collection_name: collectionName },
      }),
    }),
  }),
});

export const {
  useGetUidDictQuery,
  useLazyGetUidDictQuery,
  useUpdateUidDictMutation,
  useDeleteUidDictMutation,
  useLazyGetSearchableListQuery,
} = uidDictApi;
